import React, {ReactElement} from 'react';
import {BackstageTheme, createTheme, lightTheme, SimpleThemeOptions} from '@backstage/theme';
import {ThemeProvider} from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import LightIcon from '@material-ui/icons/WbSunny';
import {AppTheme} from "@backstage/core-plugin-api";
import {BackstageOverrides} from '@backstage/core-components';
import {BackstageOverrides as CatalogReactOverrides} from '@backstage/plugin-catalog-react';
import {WAVELO_LIGHT_THEME_CONSTANTS} from "./ThemeConstants";

interface SetStyleCallback {
    (theme: BackstageTheme): void;
}
interface IWaveloThemeProperty {
    id: string;
    title: string;
    variant: 'light' | 'dark';
    icon: ReactElement;
    themeOptions: SimpleThemeOptions;
    overrides?: BackstageOverrides & CatalogReactOverrides;
    setStyleCallback?: SetStyleCallback;
}

class WaveloThemeFactory implements AppTheme {
    id: string;
    title: string;
    variant: 'light' | 'dark';
    icon: ReactElement;
    themeOptions: SimpleThemeOptions;
    overrides?: BackstageOverrides & CatalogReactOverrides;
    setStyleCallback?: SetStyleCallback;
    Provider;
    constructor(config: IWaveloThemeProperty) {
        this.id = config.id;
        this.title = config.title;
        this.variant = config.variant;
        this.themeOptions = config.themeOptions;
        this.overrides = config.overrides;
        this.setStyleCallback = config.setStyleCallback;
        this.icon = <LightIcon/>;
        this.Provider = ({children}: any): ReactElement => {
            return (
                <ThemeProvider theme={this.createTheme()}>
                    <CssBaseline>{children}</CssBaseline>
                </ThemeProvider>
            )
        }
        return this;
    }

    createTheme = (): BackstageTheme => {
        // Create Theme <BackstageTheme>
        const outputTheme = createTheme(this.themeOptions);
        // Update specific styles in the Theme
        if (this.setStyleCallback) {
            this.setStyleCallback(outputTheme);
        }
        // Set overrides
        if (this.overrides) {
            outputTheme.overrides = {
                ...this.overrides
            }
        }
        // output finished Theme
        return outputTheme;
    }
}


const createWaveloLightThemeOverrides = (): BackstageOverrides & CatalogReactOverrides => {
    return {
        BackstageHeader: {
            header: {
                backgroundImage: 'unset',
                backgroundColor: WAVELO_LIGHT_THEME_CONSTANTS.COLOURS.PRIMARY.primary_1,
                boxShadow: 'unset',
            },
            title: {
                color: '#FFFFFF',
                fontWeight: 900,
                fontFamily: WAVELO_LIGHT_THEME_CONSTANTS.FONTS.headers
            },
        }
    };
};
const setupWaveloLightThemeStyles = (theme: BackstageTheme) => {
    theme.typography.h1.fontFamily = WAVELO_LIGHT_THEME_CONSTANTS.FONTS.headers;
    theme.typography.h2.fontFamily = WAVELO_LIGHT_THEME_CONSTANTS.FONTS.headers;
    theme.typography.h3.fontFamily = WAVELO_LIGHT_THEME_CONSTANTS.FONTS.headers;
    theme.typography.h4.fontFamily = WAVELO_LIGHT_THEME_CONSTANTS.FONTS.headers;
    theme.typography.h5.fontFamily = WAVELO_LIGHT_THEME_CONSTANTS.FONTS.headers;
}
export const waveloLightTheme = new WaveloThemeFactory({
    id: 'wavelo-default-light',
    title: 'Wavelo Light',
    variant: 'light',
    icon: <LightIcon/>,
    themeOptions: {
        palette: lightTheme.palette,
        fontFamily: WAVELO_LIGHT_THEME_CONSTANTS.FONTS.body,
        defaultPageTheme: 'home',
    },
    setStyleCallback: setupWaveloLightThemeStyles,
    overrides: {
        ...lightTheme.overrides,
        ...createWaveloLightThemeOverrides(),
    }
});


